import type { ReactNode } from 'react';
import React, { Fragment } from 'react';
import type { TextProps } from '@balance-web/text';
import { Text } from '@balance-web/text';

import { useTableContext } from '../tableContext';

type CellContentProps = TextProps & { children: ReactNode };
export function CellContent({ children, ...textProps }: CellContentProps) {
  const { overflowStrategy } = useTableContext();

  if (children === null) {
    return null;
  }

  if (isText(children)) {
    return (
      <Text tabularNumbers overflowStrategy={overflowStrategy} {...textProps}>
        {children}
      </Text>
    );
  }

  return <Fragment>{children}</Fragment>;
}

function isText(value: ReactNode): value is string | number {
  return typeof value === 'string' || typeof value === 'number';
}
